import dayjs from 'dayjs';
import React from 'react';

import Translate from '@travel/traveler-core/components/Translate';
import { DEFAULT_ADULT, DEFAULT_ROOMS } from '@travel/traveler-core/constants';

import type { SearchFormQuery } from '../types/providerList';

function usePriceLabel(searchParam?: SearchFormQuery) {
  const adultCount = searchParam?.adults ? parseInt(searchParam.adults) : DEFAULT_ADULT;
  const childCOunt = searchParam?.childrenAges ? searchParam.childrenAges.split(',').length : 0;
  const noOfRooms = searchParam?.noOfUnits ? parseInt(searchParam.noOfUnits) : DEFAULT_ROOMS;
  const guestCount = adultCount + childCOunt;

  const nightCount =
    searchParam?.startDate && searchParam?.endDate
      ? dayjs(searchParam.endDate).diff(dayjs(searchParam.startDate), 'day')
      : 1;

  const chargeUnitLabel = !Boolean(adultCount && nightCount) && (
    <Translate id="Provider_Info.Room_List.Plan_Info.Room" data={{ price: '' }} />
  );
  const roomsLabelText = Boolean(adultCount && nightCount) && (
    <Translate
      id="Common_Plan_Details.Reservation_Details.Number_Rooms.Rooms"
      count={noOfRooms}
      data={{ room_count: noOfRooms }}
    />
  );
  const guestLabel = (
    <Translate
      id="Provider_Info.Filter.Guest_Total"
      count={guestCount}
      data={{
        total_number_guests: guestCount,
      }}
    />
  );
  const nightLabel = (
    <Translate
      id="Provider_List.Search_Results.Nights"
      count={nightCount}
      data={{ length_of_stay: nightCount }}
    />
  );

  return {
    chargeUnitLabel,
    roomsLabelText,
    guestLabel,
    nightLabel,
    guestCount,
  };
}

export default usePriceLabel;
